/* VOIDLOOK global interactions
   Size-chart zoom + section reveal animations. */

/*
          Zoom de la guía de medidas.
          Un único listener de click gestiona abrir/cerrar.
        */
        (function () {
          const modal =
            document.getElementById('voidlook-fullscreen-zoom');

          const modalImage =
            document.getElementById('voidlook-fullscreen-image');

          if (!modal || !modalImage) return;

          function openZoom(image) {
            if (!image) return;

            modalImage.src =
              image.currentSrc ||
              image.src;

            modalImage.alt =
              image.alt ||
              'Guía de medidas ampliada';

            modal.classList.add('voidlook-active');

            modal.setAttribute(
              'aria-hidden',
              'false'
            );

            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
          }

          function closeZoom() {
            modal.classList.remove('voidlook-active');

            modal.setAttribute(
              'aria-hidden',
              'true'
            );

            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
          }

          document.addEventListener(
            'click',
            function (event) {
              const sizeChart =
                event.target.closest?.('.voidlook-size-chart');

              if (sizeChart) {
                event.preventDefault();
                openZoom(sizeChart);
                return;
              }

              if (
                event.target.closest?.('#voidlook-fullscreen-close') ||
                event.target === modal ||
                event.target === modalImage
              ) {
                event.preventDefault();
                closeZoom();
              }
            }
          );

          document.addEventListener(
            'keydown',
            function (event) {
              if (
                event.key === 'Escape' &&
                modal.classList.contains('voidlook-active')
              ) {
                closeZoom();
              }
            }
          );
        })();


(function () {
          /*
            MOTOR V2:
            esta es la lógica que ya comprobaste que funciona.
          */

          if (window.__voidlookRevealV25Loaded) {
            return;
          }

          window.__voidlookRevealV25Loaded = true;

          const prepared = new WeakSet();

          const observer =
            new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  if (!entry.isIntersecting) {
                    return;
                  }

                  entry.target.classList.add(
                    'vl-reveal-visible'
                  );

                  observer.unobserve(
                    entry.target
                  );
                });
              },
              {
                threshold: 0.06,
                rootMargin: '0px 0px -5% 0px'
              }
            );


          function isUsableElement(element) {
            if (
              !element ||
              element.nodeType !== 1
            ) {
              return false;
            }

            const tag =
              element.tagName.toLowerCase();

            return !(
              tag === 'script' ||
              tag === 'style' ||
              tag === 'link'
            );
          }


          function mustSkip(element) {
            if (!element) {
              return true;
            }

            if (
              element.hidden ||
              element.getAttribute('aria-hidden') === 'true'
            ) {
              return true;
            }

            /*
              No tocamos HERO.
            */
            if (
              element.matches('.voidlook-hero-container') ||
              element.querySelector('.voidlook-hero-container')
            ) {
              return true;
            }

            /*
              No tocamos la franja roja interactiva.
            */
            if (
              element.matches('[data-voidlook-scroll]') ||
              element.querySelector('[data-voidlook-scroll]')
            ) {
              return true;
            }

            return false;
          }


          function getTargets() {
            const main =
              document.getElementById('MainContent');

            if (!main) {
              return [];
            }

            let targets =
              Array.from(main.children)
                .filter(isUsableElement);

            if (targets.length <= 1) {
              const nested =
                Array.from(
                  main.querySelectorAll(
                    '[id^="shopify-section-"], .shopify-section'
                  )
                )
                .filter(isUsableElement);

              if (nested.length > 1) {
                targets = nested;
              }
            }

            return Array.from(
              new Set(targets)
            );
          }


          /*
            Añade stagger dentro de producto, archivo,
            contacto y secciones de imágenes.
            NO añade observers adicionales.
          */
          function decorateInnerElements(section) {
            if (!section || mustSkip(section)) {
              return;
            }

            const mediaSelectors = [
              '.product-media',
              '.product-media-container',
              '.card-gallery',
              '.resource-list__item',
              '.vl-archive__photo',
              '.vl-archive__item',
              '.image-with-text__media'
            ];

            const normalSelectors = [
              '.product-information > *',
              '.product__info-wrapper > *',
              '.product-info > *',
              '.product-form',
              '.product-form-buttons',
              '.product-form__buttons',
              '.price',
              'variant-picker',
              '.variant-picker',
              '.contact-form > *',
              'form[action*="/contact"] > *',
              '.contact__fields > *',
              '.newsletter-form',
              'details'
            ];

            const used = new Set();
            let delay = 0;

            section
              .querySelectorAll(
                mediaSelectors.join(',')
              )
              .forEach(function (element) {
                if (used.has(element)) return;

                used.add(element);

                element.classList.add(
                  'vl-inner-media'
                );

                element.style.setProperty(
                  '--vl-inner-delay',
                  Math.min(delay, 6) * 70 + 'ms'
                );

                delay += 1;
              });

            section
              .querySelectorAll(
                normalSelectors.join(',')
              )
              .forEach(function (element) {
                if (used.has(element)) return;

                /*
                  Evita animar un elemento y también
                  todos sus hijos duplicando el efecto.
                */
                const parentAlreadyUsed =
                  Array.from(used).some(
                    function (candidate) {
                      return candidate.contains(element);
                    }
                  );

                if (parentAlreadyUsed) return;

                used.add(element);

                element.classList.add(
                  'vl-inner-reveal'
                );

                element.style.setProperty(
                  '--vl-inner-delay',
                  Math.min(delay, 7) * 65 + 'ms'
                );

                delay += 1;
              });
          }


          function prepareTargets() {
            const targets =
              getTargets();

            targets.forEach(
              function (element, index) {
                if (
                  prepared.has(element) ||
                  mustSkip(element)
                ) {
                  return;
                }

                prepared.add(element);

                element.classList.add(
                  'vl-reveal-target'
                );

                element.dataset.vlDelay =
                  String(index % 3);

                decorateInnerElements(element);
              }
            );

            if (!targets.length) {
              return;
            }

            document.documentElement.classList.add(
              'vl-reveal-ready'
            );

            void document.body.offsetHeight;

            window.requestAnimationFrame(
              function () {
                window.requestAnimationFrame(
                  function () {
                    targets.forEach(
                      function (element) {
                        if (
                          prepared.has(element) &&
                          !mustSkip(element) &&
                          !element.classList.contains(
                            'vl-reveal-visible'
                          )
                        ) {
                          observer.observe(element);
                        }
                      }
                    );
                  }
                );
              }
            );
          }


          function init() {
            prepareTargets();
          }


          if (
            document.readyState === 'loading'
          ) {
            document.addEventListener(
              'DOMContentLoaded',
              init,
              { once: true }
            );
          } else {
            init();
          }


          document.addEventListener(
            'shopify:section:load',
            function () {
              window.setTimeout(
                prepareTargets,
                80
              );
            }
          );


          const main =
            document.getElementById('MainContent');

          if (
            main &&
            typeof MutationObserver !== 'undefined'
          ) {
            const mutationObserver =
              new MutationObserver(
                function () {
                  prepareTargets();
                }
              );

            mutationObserver.observe(
              main,
              {
                childList: true,
                subtree: false
              }
            );
          }
        })();
